export default {
  name: "AppFooter"
};